import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyStateComponent } from './empty-state.component';
import { ButtonModule } from '../../elements/button/button.module';
import { SharedModule } from '../../helper/shared.module';
import { TooltipModule } from '../../elements/tooltip/tooltip.module';
import { ImageFilterDirective } from '../../helper/directives/imgfilter.directive';



@NgModule({
  declarations: [
    EmptyStateComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    ImageFilterDirective,
    SharedModule,
    TooltipModule
  ],
  exports: [
    EmptyStateComponent
  ]
})
export class EmptyStateModule { }
